import { render, staticRenderFns } from "./shipBase.vue?vue&type=template&id=2a47681e&"
import script from "./shipBase.vue?vue&type=script&lang=js&"
export * from "./shipBase.vue?vue&type=script&lang=js&"
import style0 from "./shipBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports